// extracted by css-extract-rspack-plugin
export default {"labelWrapper":"qsAql","label":"ZeRPP","labelActive":"qFITN"};